import promosSaga from '~/sagas/promos/promos.saga';

export default promosSaga;
